var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4359 17.9619C20.474 18.1803 22.0667 19.9072 22.0667 22V22.7148L22.0179 22.7305C21.8898 22.7703 19.8181 23.4004 16.0003 23.4004C12.1699 23.4004 10.0966 22.7666 9.98079 22.7305L9.93294 22.7148V22C9.93294 19.9073 11.5258 18.1804 13.5638 17.9619C14.2922 18.3567 15.1122 18.5996 16.0003 18.5996C16.8882 18.5996 17.7077 18.3566 18.4359 17.9619Z",
    fill: "#F2994A",
    stroke: "#F2994A",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.59961C17.8746 8.59961 19.4004 10.1254 19.4004 12C19.4004 12.9292 19.0179 13.9661 18.376 14.7676C17.7346 15.5682 16.8923 16.0664 16 16.0664C15.1077 16.0664 14.2654 15.5682 13.624 14.7676C12.9821 13.9661 12.5996 12.9292 12.5996 12C12.5996 10.1254 14.1254 8.59961 16 8.59961Z",
    fill: "#F2994A",
    stroke: "#F2994A",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.3f627efa0291ad7848d48d8241f750e9.svg";
export { ForwardRef as ReactComponent };